import { createAsyncThunk } from "@reduxjs/toolkit";
import paymentService from "../../../api/services/payment";

export const fetchRequestWithdrawal = createAsyncThunk(
  "payments/fetch-request-withdrawal",
  async (requestData) => {
    return await paymentService.getRequestWithdrawals(requestData ?? {});
  }
);

export const createRequestWithdrawal = createAsyncThunk(
  "payments/create-request-withdrawal",
  async (requestData) => {
    return await paymentService.createRequestWithdrawal(requestData);
  }
);
